import { Button } from '@/components/ui/button';
import { StarFilledIcon } from '@radix-ui/react-icons';
import { Bookmark, EllipsisVertical, Star } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const SearchResultsCard = ({
  item,
  index,
  bookmarks,
  toggleBookmark,
  selectedToCompare,
  toggleSelect,
}) => {
  const navigate = useNavigate();
  const isBookmarked = bookmarks.some(
    (bookmark) => bookmark.manufacturer_id === item.manufacturer_id,
  );

  const isSelected = selectedToCompare.some(
    (manufacturer) => manufacturer.manufacturer_id === item.manufacturer_id,
  );

  return (
    <div
      key={item.manufacturer_id}
      className={`flex flex-col justify-between font-roboto border rounded-lg p-3 ${isSelected ? 'bg-purple-100' : 'bg-[#F2F4F7]'} transition-all ease-in duration-200`}
      onClick={() => toggleSelect(item)}
    >
      <div>
        {/* image */}
        <div className="bg-[#B2BBC6] h-24 w-full rounded"></div>

        {/* Main details */}
        <div className="flex flex-row justify-between items-center mt-2">
          <div className="flex flex-row items-center space-x-2">
            <div className="bg-gray-300 h-9 w-9 rounded"></div>
            <div className="flex flex-col ">
              <div className="flex flex-row space-x-2 items-center font-semibold">
                <p className="text-sm text-gray-700">{item?.company_name}</p>
                <div className="text-gray-400 text-xs flex space-x-1 items-center">
                  <StarFilledIcon color="#FBBF24" className="h-4 w-4" />
                  <p>{item?.rating}</p>
                </div>
              </div>
              <div className="text-sm">Status</div>
            </div>
          </div>
          <EllipsisVertical className="text-gray-700" />
        </div>

        {/*Certifications & Capabilities */}
        <div className="mt-2 text-[11px]">
          <div className="grid grid-cols-10">
            <div className="col-span-3 text-gray-800 font-medium">
              Certifications:
            </div>
            <div className="col-span-7 text-gray-600">
              {item?.certifications?.join(', ')}
            </div>
          </div>
          <div className="grid grid-cols-10">
            <div className="col-span-3 text-gray-800 font-medium">
              Capabilities:
            </div>
            <div className="col-span-7 text-gray-600">
              {item?.capabilities?.join(', ')}
            </div>
          </div>
        </div>
      </div>

      <div className="mt-3 flex space-x-2 justify-between items-center">
        <Button
          variant="outline"
          className="w-full text-darkPurple border-darkPurple text-base hover:text-darkerPurple hover:border-darkerPurple hover:bg-[#F2F4F7] ease-in duration-200"
          onClick={(e) => {
            e.stopPropagation();
            navigate(`/manufacturer/${item.manufacturer_id}`);
          }}
        >
          View Details
        </Button>
        <Button
          variant="outline"
          className=""
          onClick={(e) => {
            e.stopPropagation();
            toggleBookmark(item);
          }}
        >
          <Star
            className={`h-6 w-6 transition-all duration-200 ${
              isBookmarked ? 'fill-darkPurple text-darkPurple' : 'text-black'
            }`}
          />
        </Button>
      </div>
    </div>
  );
};

export default SearchResultsCard;
